import Form, {
  ButtonItem,
  ButtonOptions,
  GroupItem,
  Label,
  SimpleItem,
} from 'devextreme-react/form';
import React, { useCallback, useRef } from 'react';
import { postApi } from '../../../../apiUtils';
import { useTranslation } from '../../../../contexts/translation';
import { API_URL } from '../../../../utils/apiUrl';
import './styles.scss';

interface Props {
  taskId: number;
  visible: boolean;
  onSuccess: (comment: any) => void;
}

export const TaskServiceCommentsForm = ({ taskId, visible, onSuccess }: Props) => {
  const { translate } = useTranslation();
  const transFormName = 'Task.ServiceDeskComment';

  const formRef = useRef<any>();
  const formData = useRef<any>({});

  const onSubmit = useCallback(async () => {
    await postApi({
      url: API_URL.TASK_COMMENT_NEW,
      data: { ...formData.current, taskId },
      callAfterSuccess: async (data) => {
        onSuccess(data);
      },
    });
  }, []);

  return (
    <div className={`task-service-comment-form-container${!visible ? ' hidden' : ''}`}>
      <form>
        <Form formData={formData.current} ref={formRef} colCount={3}>
          <SimpleItem
            dataField="comment"
            editorType="dxHtmlEditor"
            colSpan={3}
            editorOptions={{
              height: 250,
              resizable: {
                handles: 's', // pouze vertikální resize (spodní hrana)
              },
              toolbar: {
                items: [
                  'undo',
                  'redo',
                  'bold',
                  'italic',
                  'underline',
                  'strike',
                  'alignLeft',
                  'alignCenter',
                  'alignRight',
                  'alignJustify',
                  'orderedList',
                  'bulletList',
                  'fontSize',
                  'fontColor',
                  'color',
                  'background',
                  'link',
                  'clear',
                ],
              },
              mediaResizing: {
                enabled: true,
              },
            }}
          >
            <Label location={'top'} text={translate!('New comment', transFormName)} />
          </SimpleItem>
          <GroupItem colCount={7} colSpan={3}>
            <ButtonItem colSpan={1} verticalAlignment={'center'} horizontalAlignment={'left'}>
              <ButtonOptions
                width={'100%'}
                text={translate!('Save', transFormName)}
                type={'success'}
                useSubmitBehavior={false}
                onClick={() => onSubmit()}
              />
            </ButtonItem>
          </GroupItem>
        </Form>
      </form>
    </div>
  );
};
